import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  class: "vue-skip-to__nav",
  "aria-labelledby": "list-title"
}
const _hoisted_2 = { id: "list-title" }
const _hoisted_3 = { class: "vue-skip-to__nav-list" }
const _hoisted_4 = ["onKeydown"]

import type { PropType } from 'vue'
import {
  toRefs
} from 'vue'
import { ISkipLink } from './vue-skip-to.interface'

// Personal
import VueSkipToSingle from './VueSkipToSingle.vue'

/**
 * Events
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'VueSkipToList',
  props: {
  listLabel: { required: false, type: String, default: 'Skip to' },
  to: {
    required: false,
    type: Object as PropType<Array<ISkipLink>>
  }
},
  emits: [ 'focus-within' ],
  setup(__props, { emit: __emit }) {

// Vendor
const emits = __emit

/**
 * Properties
 */
const properties = __props
const { listLabel, to } = toRefs(properties)

/**
 * Methods
 */
function handleKeydown ({ key, target }) {
  const parent = target.parentElement
  const itemList = /(ArrowUp|Up)/g.test(key) ? parent.previousElementSibling : parent.nextElementSibling
  if (!itemList) return
  const link = itemList.getElementsByTagName('a')
  if (link.length) link[0].focus()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(listLabel)), 1 /* TEXT */),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(to), (el) => {
        return (_openBlock(), _createElementBlock("li", {
          key: el.anchor,
          class: "vue-skip-to__nav-list-item",
          onKeydown: [
            _withKeys(_withModifiers(handleKeydown, ["prevent"]), ["up"]),
            _withKeys(_withModifiers(handleKeydown, ["prevent"]), ["down"])
          ]
        }, [
          _createVNode(VueSkipToSingle, {
            anchor: el.anchor,
            label: el.label,
            "aria-label": el.ariaLabel || el.label,
            onFocused: _cache[0] || (_cache[0] = ($event: any) => (emits('focus-within', $event)))
          }, null, 8 /* PROPS */, ["anchor", "label", "aria-label"])
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_4))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})